import { render, staticRenderFns } from "./vivaWantingList.vue?vue&type=template&id=4563ded0&scoped=true&"
import script from "./vivaWantingList.vue?vue&type=script&lang=js&"
export * from "./vivaWantingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563ded0",
  null
  
)

export default component.exports